export default "__VITE_ASSET__DFnMIiKd__"